<template>
    <div class="background">   
        <Button 
            v-for="option in options" class="equal-width" 
            :class="{ 'px24': this.$store.state.resize.w > 768, 'truncate-btn': truncate }" 
            :id="`csb-${id}-${option.value}`"
            :key="option.value" 
            @click="changeStage(option.value)" 
            :type="modelValue === option.value ? 'btn-toggle-active' : 'btn-toggle'"
        >
            <span 
                class="neue fw-medium text-nowrap" 
                :class="{
                    'fsp12': small && this.$store.state.resize.w <= 768,
                    'fsp14': !small || this.$store.state.resize.w > 768, 
                    'd-flex align-items-center gap-1': option.count,
                    'text-ellipsis': truncate
                }"
            >
                <span>{{ option.label }}</span>
                <span v-if="option.count" class="active-filters-count" :class="{ 'count-non-active': modelValue !== option.value }">
                    {{ option.count }}
                </span>
            </span>
        </Button> 
    </div>
</template>
<script>
import Button from './Button.vue';

export default {
    components: {
        Button
    },
    props: {
        options: [Array],
        modelValue: [String, Number],
        small: [Boolean],
        truncate: [Boolean],
        id: {type: [String, Boolean], default: '0'}
    },
    methods: {
        changeStage(value) {
            this.$emit('update:modelValue', value);
            this.$emit('changeStage', value);
        }
    },
    created() {
        console.log('options', this.options);
        console.log('modelValue', this.modelValue);
    }
}
</script>
<style lang="scss" scoped>
.background {
    display: inline-flex;
    background-color: $bg-light-grey;
    border: 1px solid $primary-stroke;
    border-radius: 8px;
    padding: 4px;
    gap: 4px;
    height: 40px;
    max-width: 100%;
    
    @media (max-width: 768px) {
        width: 100%;

        button {
            flex: 1 1 0;
        }
    }
}

.truncate-btn {
    flex: 0 1 auto;
    min-width: 0;
    overflow: hidden;

    span {
        @media (max-width: 400px) {
            display: flex;
        }
    }
}

.text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: block;
    width: 100%;
}

.count-non-active {
    background: $primary-stroke;
    color: $primary-grey;
}
</style>